import * as React from "react";

import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import { Button } from "#components/primitive/button";
import { useAnalytics } from "#structure/providers/analytics/analytics-provider";
import { useAmplitudeBaseContext } from "#resources/hooks/use-amplitude-base-context";

import Icon from "#components/icon";
import s from "./suport-area.scss";
import { useZendeskSupport } from "#resources/hooks/use-zendesk-support";

const DEFAULT_WIDTH_DESKTOP = 466;
const DEFAULT_WIDTH_MOBILE = "100%";
interface SuportAreaProps {
	type: "mobile" | "desktop";
	isOpen: boolean;
	placeName: string;
	handleChangeIsOpen: (isOpen: boolean) => void;
}
export function SuportArea({
	type,
	isOpen,
	handleChangeIsOpen,
}: SuportAreaProps) {
	const { t } = useTranslation("components", { keyPrefix: "suportArea" });
	const { sendEvent } = useAnalytics();
	const baseContext = useAmplitudeBaseContext();
	const { openSupport } = useZendeskSupport();

	const handleClose = () => {
		handleChangeIsOpen(false);
	};

	const handleContactSupport = () => {
		sendEvent("support_chat_widget", baseContext);
	};

	return (
		<div>
			{isOpen ? (
				<Drawer
					className={s.suportArea}
					width={type === "mobile" ? DEFAULT_WIDTH_MOBILE : DEFAULT_WIDTH_DESKTOP}
					open={isOpen}
					title={
						<div className={s.headerInfos}>
							{type === "mobile" && <div className={s.handleMobile} />}
							<div className={s.titleContainer}>
								<h1 className={s.title}>{t($ => $.title)}</h1>
								{type === "desktop" && (
									<Icon icon="close" className={s.closeButton} onClick={handleClose} />
								)}
							</div>
						</div>
					}
					placement={type === "mobile" ? "bottom" : "right"}
					closable={false}
					onClose={handleClose}
					footer={
						type === "desktop" && (
							<div className={s.footer}>
								<Button variant="ghost" onClick={handleClose}>
									{t($ => $.close)}
								</Button>
							</div>
						)
					}
				>
					<div className={s.containerContacts}>
						<div className={s.contactWhatsApp}>
							<Icon className={s.iconChat} icon="chat" />
							<h2>{t($ => $.questionTitle)}</h2>
							<span>{t($ => $.questionDescription)}</span>
							<button
								className={s.link}
								onClick={() => {
									handleContactSupport();
									openSupport();
								}}
							>
								<span>{t($ => $.openTicket)}</span>
								<Icon icon="arrow-right" />
							</button>
						</div>
					</div>
				</Drawer>
			) : null}
		</div>
	);
}
